<template>
  <div class="wp_guestLoginItems">
			<div class="wp_UserDp">
				<img
					:src="$t(unAuthenticatedUserNavTexts.noProfilePictureImage)"
					alt="profilePic"
					data-test="authenticatedUserModalImg3"
					id="authenticatedUserModalImg3"
				/>
			</div>
    <span data-test="unAuthenticatedModalsSpan1" id="unAuthenticatedModalsSpan1">
      {{$t(unAuthenticatedUserNavTexts.userDisplayName)}}
    </span>
    <a href=""
       @click.prevent="$router.push('/signup')"
       id="unAuthenticatedModalsSignUpLink"
       data-test="unAuthenticatedModalsSignUpLink"
    >
      {{$t(unAuthenticatedUserNavTexts.signUpLinkText)}}
    </a>
    <span id="unAuthenticatedModalsSpan2" data-test="unAuthenticatedModalsSpan2">|</span>
    <a href=""
       id="unAuthenticatedModalsLoginLink"
       @click.prevent="$router.push({path: '/login', query: {next_to: 'previous'}})"
       data-test="unAuthenticatedModalsLoginLink"
    >
					{{$t(unAuthenticatedUserNavTexts.loginLinkText)}}
    </a>
    <span id="vendor-signin-symbl" data-test="unAuthenticatedModalsSpan3">|</span>
    <a href=""
       id="unAuthenticatedModalsSellerLoginLink"
       @click.prevent="$router.push({path: '/vendorLogin'})"
       data-test="unAuthenticatedModalsSellerLoginLink"
    >
					{{$t(unAuthenticatedUserNavTexts.sellerLoginLinkText)}}
    </a>
  </div>
</template>
<script>
export default {
	name: 'un-authenticated-models',
	props: {
		unAuthenticatedUserNavTexts: {
			type: Object,
			default: () => {}
		}
	}
}
</script>
